import User from './User';
import Office from './Office';
import BillingAndPaymentCycle from './BillingAndPaymentCycle';

export default class ProjectStaff {
    id?: number;
    projectId?: number;
    user?: User;
    userId?: number;
    office?: Office;
    manager?: User;
    startDate?: Date;
    endDate?: Date;
    projectAdministratorId?: number;
    projectManagerId?: number;
    pcapmId?: number;
    overrideBillRate?: number;
    overridePayRate?: number;
    isOverride?: boolean;
    pendingCycle?: boolean;
    startBillingCycle?: BillingAndPaymentCycle;
    startBillingCycleId?: number;
    endBillingCycle?: BillingAndPaymentCycle;
    endBillingCycleId?: number;
    ownershipAccess?: boolean;
    contractAccess?: boolean;
    reportAccess?: boolean;
    workClassificationId?: number;

    constructor() {
        this.user = new User();
        this.office = new Office();
        this.manager = new User();
        this.startDate = new Date();
        this.endDate = new Date();
    }
}



// WEBPACK FOOTER //
// ./src/models/ProjectStaff.ts